module.exports = __webpack_public_path__ + "img/lluvia_red.bef58e78.svg";